// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFoundPage_notFoundContainer__tBga7","notFoundImage":"NotFoundPage_notFoundImage__JemmG","homeButton":"NotFoundPage_homeButton__r+gxo"};